import React from 'react';
import Button from '@material-ui/core/Button';
import UpArrow from '@material-ui/icons/KeyboardArrowUp';
import DownArrow from '@material-ui/icons/KeyboardArrowDown';
import styled from 'styled-components';

const ButtonContainer = styled.div`
    position:relative; 
    left:-13px;
`

const TableHeaderSortButton = ({title,property,propertyToSortBy,sortReverse,onClick = ()=>{} }) => {


    let endIcon = null;

    if(propertyToSortBy === property)
    {
        if(!sortReverse){
            endIcon = <DownArrow fontSize='small' color="primary"/>
        }else {
            endIcon = <UpArrow fontSize='small' color="primary"/>

        }
    }
    return <ButtonContainer >
            <Button style={{justifyContent:'left'}}
            color="primary" 
            onClick={()=>onClick(property)}
            >
                {title}<span>{endIcon}</span>
            </Button>
            </ButtonContainer>
}


export default TableHeaderSortButton;